
import CustomerCollapse from "./components/CustomerCollapse.vue"
import CustomerList from "./components/CustomerList.vue"
import Events from "./components/Events.vue"
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { Component, Vue } from "vue-property-decorator"
import {Customer as CustomerApi} from '@/services/SOLO'
import Translations from './components/Translations.vue'
import { translations } from '@/mixins'

@Component({
  components: {
    RouteBreadCrumb,
    CustomerList,
    CustomerCollapse,
    Events
  },
  mixins: [translations]

})

export default class Customers extends Vue {
public translate!: Function

  $notify: any
  tab: any = 1

  exportAllCustomer() {


      CustomerApi.exportAllCustomer()
          .then(response => {
                  this.$notify({
                    title: "PLEASE WAIT!",
                    horizontalAlign: "right",
                    message: response.data.message,
                    type: "success",
                    icon: "fas fa-spinner fa-spin",
                  })

          }).catch(error => {
            this.$notify({
              title: "ERROR!",
              horizontalAlign: "right",
              message: error.response.data.message || error.response.data.error?.[0]?.detail,
              type: "danger",
              icon: "fas fa-exclamation-triangle",
            })
          }) 
  }

  get dropDownText(): string {
    if (this.tab === 1) {
      return this.translate('Customers')
    } else {
      return this.translate('Events')
    }                   
  }


}
